import { FarmNftItemV1 } from "./FarmNftItemV1";
import { FarmNftMinterV1 } from "./FarmNftMinterV1";

export const FARM = {
  NftItem: FarmNftItemV1,
  NftMinter: FarmNftMinterV1,
} as const;
